import { Box, Typography } from "@mui/material";

import ArrowIconVertical from "@/assets/icons/fleet-inquiry/stepper-arrow-left.svg?react";
import ArrowIconHorizontal from "@/assets/icons/fleet-inquiry/stepper-arrow-sm.svg?react";
import { FONT_PRIMARY, FONT_SECONDARY } from "@/theme/typography";
import {
  fleetInquiryHorizontalTextStyles,
  fleetInquiryIconStyles,
  fleetInquiryTextStyles,
  getFleetInquiryHorizontalIconStyles,
} from "./styles";

interface IProps {
  title: string;
  type: "vertical" | "horizontal";
  index: number;
}

const FleetInquiryLabel: React.FC<IProps> = ({ title, type, index }) => {
  const iconStyles =
    type === "vertical"
      ? fleetInquiryIconStyles
      : getFleetInquiryHorizontalIconStyles(index);

  const textStyles =
    type === "vertical"
      ? fleetInquiryTextStyles
      : fleetInquiryHorizontalTextStyles;
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      flexDirection={type === "vertical" ? "row" : "column"}
      sx={iconStyles}
    >
      <Typography
        variant="subtitle1"
        component="span"
        color="text.primary"
        fontWeight={700}
        fontFamily={{ xs: FONT_SECONDARY, md: FONT_PRIMARY }}
        fontSize={{ xs: "1rem", md: "1.25rem" }}
        sx={textStyles}
      >
        {title}
      </Typography>

      {type === "vertical" ? <ArrowIconVertical /> : <ArrowIconHorizontal />}
    </Box>
  );
};

export default FleetInquiryLabel;
